import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Slider = ({ onSlide, index }) => {
  const [mouseIsDown, setMouseIsDown] = useState(false);
  const [delta, setDelta] = useState(0);
  const [barX, setBarX] = useState();

  const xOrigin = useRef();
  const body = document.querySelector('body');

  useEffect(() => {
    // Función que se ejecuta cuando el mouse está en movimiento
    const mouseMoveHandler = (event) => {
      if (!xOrigin.current) {
        xOrigin.current = event.x;
      }
      const diff = Math.abs(xOrigin.current - event.x);
      const delta = xOrigin.current > event.x ? -diff : diff;

      setDelta(delta);
      setBarX((document.getElementById(`column-${index}`).offsetWidth + delta) - 18);
    };

    // Función que se ejecuta cuando el mouse se levantó
    const mouseUpHandler = () => {
      onSlide(delta, index);
      setMouseIsDown(false);
    };

    if (mouseIsDown) {
      body.addEventListener('mouseup', mouseUpHandler);
      body.addEventListener('mousemove', mouseMoveHandler);
    } else {
      body.removeEventListener('mousemove', mouseMoveHandler);
    }
    return () => {
      body.removeEventListener('mouseup', mouseUpHandler);
      body.removeEventListener('mousemove', mouseMoveHandler);
    };
  }, [mouseIsDown, delta, barX, onSlide, index]);

  // Función que se ejecuta cuando se da click en el mouse
  const mouseDownHandler = () => {
    setMouseIsDown(true);
    setBarX(document.getElementById(`column-${index}`).offsetWidth - 18);
  };

  Slider.propTypes = {
    // Index de la columna que se esta cambiando el ancho.
    index: PropTypes.number.isRequired,
    // función a ejecutar cuando se arrastre el slider.
    onSlide: PropTypes.func.isRequired
  };

  return (
    <>
      <ColResizer
        onMouseDown={mouseDownHandler}
      >
        ||
      </ColResizer>
      {mouseIsDown && (
        <Line style={{ left: barX }} />
      )}
    </>
  );
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const ColResizer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 8px;
  cursor: col-resize;
  user-select: none; /* Standard */
`;

const Line = styled.div`
  position: absolute;
  width: 2px;
  height: 100%;
  top: 0;
  z-index: 9999;
  background-color: ${(props) => props.theme.colors.greyDark};
`;

export default Slider;
